import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output
} from '@angular/core';
import { EventEmitterService } from 'app/api/event.service';
import { FileItem, FileUploader } from 'ng2-file-upload';
import { IMachine } from '../../api/domain-model';
import { NotificationService } from '../notifications/notification.service';
import { TranslateService } from '../translate/translate.service';
import {StorageService} from "../storage-service";
@Component({
    selector: 'file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FileUploadComponent implements OnInit, OnDestroy {
	changeDetectionSubscribe;

	title = 'ng8fileupload';
	public uploader: FileUploader = new FileUploader({ itemAlias: 'file', url: '' });
	public fileUploadingInProgress: boolean;

	@Output()
	public newMaintenanceAidsAdded = new EventEmitter<boolean>();

	@Input() fileUploadUri: string;
	@Input() onSuccessMessageKeys: Array<string>;
	@Input() onErrorMessageKeys: Array<string>;
	@Input() uploadButtonText: string;

	// tslint:disable-next-line:no-input-rename
	@Input('machine') machine: IMachine;

	getMachine(): IMachine {
		return this.machine;
	}

	get lang() {
		return window.location.pathname.split('/')[2];
	}

	constructor(
		private notificationService: NotificationService,
		private translateService: TranslateService,
		private storageService: StorageService,
		private cd: ChangeDetectorRef,
		private eventEmitterService: EventEmitterService
	) {}

	ngOnInit() {
		this.uploader.onAfterAddingFile = (file) => {
			file.withCredentials = false;
		};
		this.uploader.onSuccessItem = (item: FileItem, response: string) => {
			this.uploader.clearQueue();
			this.fileUploadingInProgress = false;
			let message = '';
			this.onSuccessMessageKeys.forEach(
				(messageKey) =>
					(message = message + ' ' + this.translateService.instant(messageKey))
			);
			this.notificationService.showOK(message);
			this.cd.markForCheck();
			this.newMaintenanceAidsAdded.emit(true);
		};

		this.uploader.onErrorItem = (item: FileItem, response: string) => {
			this.uploader.clearQueue();
			this.fileUploadingInProgress = false;
			this.cd.markForCheck();
			let message = '';
			this.onErrorMessageKeys.forEach(
				(messageKey) =>
					(message = message + ' ' + this.translateService.instant(messageKey))
			);
			this.notificationService.showError(message);
		};

		this.changeDetectionSubscribe =
			this.eventEmitterService.langtrigger.subscribe((lang) => {
				this.cd.markForCheck();
			});
	}

	uploadFile(): void {
		this.fileUploadingInProgress = true;
		this.uploader.setOptions({
			url: this.fileUploadUri,
			authTokenHeader: 'Authorization',
			authToken: `Bearer ${
				JSON.parse(this.storageService.getToken()).access_token
			}`
		});
		this.uploader.uploadAll();
	}

	ngOnDestroy(): void {
		this.changeDetectionSubscribe.unsubscribe();
	}
}
